import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ShelfSelecter from "./ShelfSelecter";
import StudSelecter from "./StudSelecter";
import StudAddSelecter from "./StudAddSelecter";
import {helper}  from "./../app.js"; 

export default class ShoreSelecter extends PureComponent 
{
    constructor (props)
    {
        super(props);

        this.state = {
            stud: this.props.init_stud,
            stud_add: this.props.init_stud_add,
            stud_conns: this.props.init_stud_conns, 
            stud_shelf_conns: this.props.init_stud_shelf_conns, 
            stud_add_conns: this.props.init_stud_add_conns,
            shelf: this.props.init_shelf,
            shelf_conns: this.props.init_shelf_conns
        };

        this.processSelected = this.processSelected.bind(this);
    }
    processSelected (item, type, showInfo = true)
    {
        if (type in this.state)
        {
            const newState = {[type]: item},
                isUnitary = this.props.is_unitary,
                hasStud = !helper.isNotObjectOrEmpty(this.state.stud);

            switch (type)
            {
                case 'stud':

                    if (null === item)
                    {
                        this.setState(
                        {
                            stud: null,                            
                            stud_add: null,
                            stud_conns: [],
                            stud_shelf_conns: [],
                            stud_add_conns: [],
                            shelf: null,
                            shelf_conns: []
                        });
                    }
                    else if (this.state.stud && item.id == this.state.stud.id)
                    {
                        this.setState(newState);
                    }
                    else
                    {
                        this.setState(
                        {
                            stud: item,
                            stud_add: null,
                            stud_conns: [],
                            stud_shelf_conns: [],
                            stud_add_conns: [],
                            shelf: null,
                            shelf_conns: []
                        });
                    }

                    this.props.on_select(item, `shore_${type}`, showInfo);
                    break;
                    
                case 'shelf':

                    if (isUnitary)
                    {
                        if (null === item)
                        {
                            this.setState(
                            {
                                stud: null,
                                stud_add: null,
                                stud_conns: [],
                                stud_shelf_conns: [],
                                stud_add_conns: [],
                                shelf: null,
                                shelf_conns: []
                            });
                        }
                        else if (this.state.shelf && item.id == this.state.shelf.id)
                        {
                            this.setState(newState);
                        }
                        else
                        {
                            this.setState(
                            {
                                stud: null,
                                stud_add: null,
                                stud_conns: [],
                                stud_shelf_conns: [],
                                stud_add_conns: [],
                                shelf: item,
                                shelf_conns: []
                            });
                        }
                    }
                    else
                        this.setState(newState);
                       

                    this.props.on_select(item, `shore_${type}`, showInfo);
                    break;    

                default:
                    this.setState(newState);

                    this.props.on_select(item, `shore_${type}`, showInfo);
                    break;
            }
        }
    }
    render () 
    {   
        let shoreSelecter = <div />;
        const hasStud = !helper.isNotObjectOrEmpty(this.state.stud),
            studArticul = hasStud ? this.state.stud.articul : '',
            trayArticul = this.props.tray_articul,
            carrierType = this.props.carrier_type,
            shoreType = this.props.shore_type,
            isUnitary = this.props.is_unitary,
            shelfProps = {
                tray_type: this.props.tray_type,
                tray_articul: trayArticul,
                shore_type: this.props.shore_type, 
                carrier_type: carrierType, 
                is_unitary: isUnitary,
                init_shelf: this.state.shelf,
                init_shelf_conns: this.state.shelf_conns
            };

        if (!isUnitary)
        {
            shelfProps.stud_articul = studArticul;
            shelfProps.init_stud_shelf_conns = this.state.stud_shelf_conns;
            shoreSelecter = <><Form.Row>
                                <StudSelecter key={`sts_${carrierType}`} on_select={this.processSelected} tray_articul={trayArticul} carrier_type={carrierType} shore_type={shoreType} init_stud={this.state.stud} init_stud_conns={null} />
                                <StudAddSelecter key={`sas_${carrierType}_${studArticul}`} on_select={this.processSelected} stud_articul={studArticul} init_stud_add={this.state.stud_add} init_stud_add_conns={null} />
                            </Form.Row>
                            <Form.Row>
                                <ShelfSelecter key={`shs_${carrierType}_${studArticul}`} on_select={this.processSelected} {...shelfProps} />
                            </Form.Row></>;
        }
        else
            shoreSelecter = <Form.Row>
                                <ShelfSelecter key={`shs_${carrierType}`} on_select={this.processSelected} {...shelfProps} />
                            </Form.Row>;

        return shoreSelecter;
    }
}